import { ComparisonSpec } from './ComparisonSpec';
import { DateTrunc } from '../DateGranularity';

export interface HistoricalComparisonSpec extends ComparisonSpec {
  readonly type: 'HISTORICAL_COMPARISON';
  // comparisonPeriod: date granularity of the comparison period
  // numberOfPeriods?: number of periods over which we're comparing
  //    if undefined, we default to 1 period
  // message: user facing message for comparison selection
  readonly comparisonPeriod: DateTrunc;
  readonly numberOfPeriods?: number;
  /**
   * `true` if the comparison line should be visible, `false` otherwise
   * `undefined` should be treated as `false`.
   */
  readonly showComparisonLine?: boolean;
}

/**
 * @param comparisonPeriod The period to compare against
 * @param message The user facing string to describe this spec. Unused outside
 * the adjust and compare screen in phoenix.
 * @param numberOfPeriods The number of `comparisonPeriod`s to look back. Defaults to 1 if unset.
 */

export const makeHistoricalComparisonSpec = (
  comparisonPeriod: DateTrunc,
  message: string,
  numberOfPeriods?: number,
  showComparisonLine: boolean = false
): HistoricalComparisonSpec => {
  return {
    type: 'HISTORICAL_COMPARISON',
    comparisonPeriod,
    numberOfPeriods: numberOfPeriods ?? 1,
    message,
    showComparisonLine,
  };
};
